import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-retailexpress',
  templateUrl: './link-retailexpress.component.html',
  styleUrls: ['./link-retailexpress.component.scss'],
})
export class LinkRetailexpressComponent implements OnInit {
  @Input() partner;
  @Input() selectedPOS;
  @Input() modal;
  @Output() next = new EventEmitter();
  public busy = true;
  public connected = false;
  public syncing = false;
  public message = null;
  public broadcastChannel = new BroadcastChannel('RETAILEXPRESS_CHANNEL');
  public win;

  public configurationSaved: boolean = false;
  public username: string = null;
  public password: string = null;
  public apiKey: string = null;
  public clientID: string = null;
  public url: string = null;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.busy = false;
  }

  SaveSettings() {
    this.posIntegrationService
      .savePOSConnection(this.partner.PartnerID, {
        PartnerID: this.partner.PartnerID,
        Username: this.username,
        Password: this.password,
        POSID: 12,
        APIKey: this.apiKey,
        StoreURL: this.url,
        ClientID: this.clientID,
      })
      .subscribe((x) => {
        if (this.modal !== undefined) this.modal.dismiss('Cross click');
        else this.next.emit();
      });
  }

  done() {
    this.next.emit();
  }

  skipToHubtiger() {
    this.router.navigateByUrl('/store/calendar');
  }
}
